import { User } from "../../classes";
import router from '../../router'

const UserModule = {
  namespaced: true,
  state: () => ({
    isLoggedIn: false,
    sessionToken: "",
    userInfo: null,
    user: null,
    dataOTP: null
  }),
  actions: {
    getUserOTP: async ({ commit }, payload) => {
      try {
        commit("setDataOTP", null);
        const data = await User.getUserOTP(payload);
        if (data && data.isSentOTP)
          commit("setDataOTP", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    loginUserOTP: async ({ commit }, payload) => {
      try {
        commit("setUser", null);
        const data = await User.loginUserOTP(payload);
        if (data && data.objectId) {
          commit("setUser", data);
          try { localStorage.setItem("sessionToken", data.sessionToken); } catch (e) { /* storage full or private browsing */ }
        }
        return data;
      } catch (err) {
        throw err;
      }
    }
  },
  getters: {
    getDataOTP: state => state.dataOTP,

    getUser: state => state.user,
    getUserInfo: state => state.userInfo,

  },
  mutations: {
    setSessionToken: (state, payload) => {
      state.sessionToken = payload.sessionToken;
    },
    resetSessionToken: (state, payload) => {
      state.sessionToken = "";
      state.isLoggedIn = payload.isLoggedIn;
      try { localStorage.removeItem("sessionToken"); } catch (e) { /* private browsing */ }
    },
    setUserInfo: (state, payload) => {
      state.userInfo = payload.user;
    },
    setUser: (state, payload) => {
      state.user = payload;
    },
    setDataOTP: (state, payload) => {
      state.dataOTP = payload;
    },
    clearUser: (state) => {
      state.isLoggedIn = false
      state.sessionToken = ""
      state.userInfo = null
      state.user = null
      state.dataOTP = null
      try { localStorage.removeItem("sessionToken"); } catch (e) { /* private browsing */ }
    },

  }
};
export default UserModule;
